import { render } from "./np-select2.vue?vue&type=template&id=c441b494&scoped=true"
import script from "./np-select2.vue?vue&type=script&lang=js"
export * from "./np-select2.vue?vue&type=script&lang=js"

import "./np-select2.vue?vue&type=style&index=0&id=c441b494&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c441b494"]])

export default __exports__